module.exports = __webpack_public_path__ + "img/icon-insights.d81b62f9.svg";